import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { config } from '../../config';

// Get configuration from centralized config
const { authority, clientId: client_id, redirectUri: redirect_uri } = config.oidc;

if (!authority || !client_id) {
  console.warn('OIDC configuration missing. Please set VITE_OIDC_AUTHORITY and VITE_OIDC_CLIENT_ID');
}

export const oidcConfig = {
  authority,
  client_id,
  redirect_uri,
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  loadUserInfo: true,
};

export const userManager = new UserManager(oidcConfig);